module.exports = __webpack_public_path__ + "assets/img/docs2.aca4fd52.svg";